import { useContext, useEffect, useState } from 'react';

import { Form as FormAntd, Radio } from 'antd';

import {
  ColSize,
  ConfirmationModal,
  ContentSection,
  Form,
  RowSize,
} from '../../../../../../../../../shared/components';
import { ModalDeleteTab, QuotationStepButtons } from '../../../../../shared';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import {
  GenericDataFormContext,
  QuotationInfoContext,
} from '../../../../../shared/contexts';
import { StepTwoFormContext } from '../../contexts/StepTwoForm';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm/WizardDataFormContext';

import { QuotationStep } from '../../../../../shared/interfaces';
import { PLAN_TYPE, PlanType } from '../../../../../shared/interfaces';
import { StepThreeFormContext } from '../../../StepThree/contexts/StepThreeForm';

export const PropertyDataConsortium = () => {
  const {
    activeKey,
    addNewTab,
    areTabActionsAllowed,
    consortiumFormValues,
    isPlanTypeADisabled,
    isPlanTypeCDisabled,
    keyTabToDelete,
    planTypeSelected,
    removeTab,
    resetTabs,
    setActiveKey,
    setConsortiumFormValues,
    setKeyTabToDelete,
    setPlanTypeSelected,
    setShowModal,
    showModal,
    stepTwoForm,
    tabs,
  } = useContext(StepTwoFormContext);
  const { handleTabErrors } = useContext(WizardDataFormContext);
  const { setActiveTab } = useContext(StepThreeFormContext);
  const { setCanShowSpinner, setUserCanDeleteTabs } = useContext(GenericDataFormContext);
  const { setCurrentStep, loadingRenewalQuotation, quotationToRenewal } = useContext(QuotationInfoContext);
  const isRenewal = loadingRenewalQuotation || quotationToRenewal;

  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [unconfirmedPlanType, setUnconfirmedPlanType] =
    useState<PlanType | null>(null);

  const onValidateForm = async () => {
    try {
      setCanShowSpinner(true);
      await stepTwoForm?.validateFields();

      setConsortiumFormValues(stepTwoForm?.getFieldsValue());
      setUserCanDeleteTabs(false);
      setCurrentStep(QuotationStep.THREE);
      setActiveTab(1);
    } catch (error: any) {
      if (error && error?.errorFields?.length > 0) {
        handleTabErrors(error?.errorFields, ['tab'], 'Integral de Consorcio');
      }
    } finally {
      setCanShowSpinner(false);
    }
  };

  const handlerBackButton = () => {
    setConsortiumFormValues(stepTwoForm?.getFieldsValue());
    setCurrentStep(QuotationStep.ONE);
  };

  const onEdit = (targetKey: any, action: 'add' | 'remove') => {
    if (action === 'add') {
      addNewTab();

      return;
    }

    setShowModal(true);
  };

  const handleOk = () => {
    if (keyTabToDelete !== null) {
      removeTab(keyTabToDelete);
      setKeyTabToDelete(null);
    }

    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    setKeyTabToDelete(null);
  };

  const handleChangePlanType = (e: any) => {
    setUnconfirmedPlanType(e.target.value);
    setShowConfirmationModal(true);
  };

  const handleCancelConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const handleConfirmActionModal = () => {
    if (unconfirmedPlanType && unconfirmedPlanType !== planTypeSelected) {
      setPlanTypeSelected(unconfirmedPlanType);

      resetTabs(unconfirmedPlanType);
    }

    setUnconfirmedPlanType(null);
    setShowConfirmationModal(false);
  };

  const handlePressTab = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  useEffect(() => {
    if (consortiumFormValues && Object.keys(consortiumFormValues).length > 0) {
      stepTwoForm?.setFieldsValue(consortiumFormValues);
    }
  }, [consortiumFormValues, stepTwoForm]);

  return (
    <>
      <Form
        formProps={{
          form: stepTwoForm,
          name: 'property-data-consortium-form',
        }}
      >
        <ContentSection level='h3' title='Tipo de Plan'>
          <RowSize>
            <ColSize size={25}>
              <FormAntd.Item label='Tipo de Plan:'>
                <Radio.Group
                  value={planTypeSelected}
                  onChange={(e) => handleChangePlanType(e)}
                  disabled={isRenewal}
                >
                  <Radio value={PLAN_TYPE.OPEN} disabled={isRenewal || isPlanTypeADisabled}>
                    Abierto
                  </Radio>
                  <Radio
                    value={PLAN_TYPE.CLOSED}
                    disabled={isRenewal || isPlanTypeCDisabled}
                  >
                    Cerrado
                  </Radio>
                </Radio.Group>
              </FormAntd.Item>
            </ColSize>
          </RowSize>
        </ContentSection>

        {tabs.length ? (
          <Tabs
            type='editable-card'
            activeKey={activeKey}
            onEdit={onEdit}
            hideAdd={!areTabActionsAllowed}
            items={tabs}
            handlePressTab={handlePressTab}
          />
        ) : (
          <></>
        )}
      </Form>

      <QuotationStepButtons
        label='Continuar'
        onClick={onValidateForm}
        onPressBackButton={handlerBackButton}
      />

      <ModalDeleteTab
        open={showModal}
        onCancel={handleCancel}
        onOk={handleOk}
      />

      <ConfirmationModal
        open={showConfirmationModal}
        onCancel={handleCancelConfirmationModal}
        onConfirm={handleConfirmActionModal}
        confirmButtonLabel='Confirmar'
        title='¿Desea cambiar el Tipo de Plan?'
        description='Si cambia el Tipo de Plan, los datos cargados de esta operación serán eliminados y tendrá que volver a cargar de vuelta todos los datos de la misma. ¿Desea continuar?'
      />
    </>
  );
};
